module.exports = __webpack_public_path__ + "img/series-8.f7506f63.png";